<template>
  <div>
    <div class="feed-item pt-8 px-6">
      <div class="item-title mb-3 font-bold">{{ post.title }}</div>
      <div class="item-desc">
        {{ post.content }}
      </div>
      <div class="actionbar h-16 flex justify-between w-full">
        <Reactions :post="post"></Reactions>
        <div class="flex justify-center items-center" v-if="detail">
          <img v-if="$route.path.indexOf(getSlug()) === -1" class=" cursor-pointer ml-4" src="../ics/comment.svg" alt="" @click="$router.push(getSlug())">
          <img v-if="$route.path.indexOf(getSlug()) === -1" class=" cursor-pointer ml-4" src="../ics/arrow-r.svg" alt="" @click="$router.push(getSlug())">
        </div>
      </div>
    </div>
    <div class="hrline"></div>
  </div>
</template>

<script>
import { Base64 } from '../../api/util'
export default {
  props: {
    detail: {
      default: true
    },
    post: {}
  },
  components: {
    Reactions: require('./Reactions.vue').default
  },
  methods: {
    getSlug () {
      return `/app/postID/${encodeURIComponent(Base64.encode(this.post._id))}`
      // '/app/post-detail/friends-help-friends-@-123456'
      // '/app/post-detail/friends-help-friends-@-123456'
    }
  }
}
</script>

<style>
</style>
